import { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  FormControl,
  TextField,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem,
} from '@mui/material';
import { useForm, Controller } from "react-hook-form";
import { manipulaEstoque } from '../configs/functions';
import { fillInputErrors, getFormErrorMessage } from '../../../../../configs/functions';
import { useCommonItems } from '../../../../../contexts/CommonItensProvider';
import { CommonDialogActionsForm } from '../../../../common/CommonDialogActionsForm';
import { getDefaultValueSelectField } from '../../../../../utils';

export function StockForm({ open, setOpen, selectedStock, empresas, empresasHasModule }) {
  const { exibirDialog, handleCloseDialog, exibirAlerta } = useCommonItems();

  const [isLoading, setIsLoading] = useState(false);

  const isEditAction = !!selectedStock;

  const {
    register,
    handleSubmit,
    setValue,
    setError,
    clearErrors,
    reset,
    control,
    formState: { dirtyFields, errors },
  } = useForm();

  const onSubmit = async (data) => {
    let formDataToSend = {};
    setIsLoading(true);
    exibirDialog('Salvando. Aguarde...');

    if (isEditAction) {
      const dirtyFieldKeys = Object.keys(dirtyFields);

      const dirtyData = dirtyFieldKeys.reduce((acc, key) => {
        if (data.hasOwnProperty(key)) {
          acc[key] = data[key];
        }
        return acc;
      }, {});

      formDataToSend = dirtyData;
      formDataToSend.id = selectedStock.estoques_id[0];
    } else {
      delete data.id;
      formDataToSend = data;
    }

    try {
      const res = await manipulaEstoque(formDataToSend, isEditAction);
      exibirAlerta('Sucesso', res.data.message, 'success');
      setOpen(false);
    } catch (error) {
      console.error(error);
      let errorMessage = "Erro ao cadastrar estoque.";
      if (error.response) {
        errorMessage = error.response.data.error
        fillInputErrors(error, setError);
      }
      exibirAlerta('Erro', errorMessage, 'error');
    } finally {
      setIsLoading(false);
      handleCloseDialog();
    }
  };

  useEffect(() => {
    // preenche o formulário ao abrir p/ edicao
    if (open) {
      const defaultValues = {
        id: selectedStock ? selectedStock.estoques_id[0] : '',
        nome: selectedStock ? selectedStock.nome : '',
        status: selectedStock ? selectedStock.status[0] : 1,
        descricao: selectedStock ? selectedStock.descricao : '',
        id_empresa: getDefaultValueSelectField(selectedStock, selectedStock?.empresas_id[0], empresas),
      };
      reset(defaultValues);
    } else {
      reset();
    }
  }, [empresas, open, reset, selectedStock]);

  return (<>
    <Dialog open={open} fullWidth maxWidth={"md"}>
      <form onSubmit={handleSubmit(onSubmit)}>
        {isEditAction
          ? <DialogTitle>Editando Estoque <strong>{selectedStock.nome}</strong></DialogTitle>
          : <DialogTitle>Cadastrar novo Estoque</DialogTitle>
        }
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            {isEditAction ? 'Preencha corretamente os dados.' : 'Preencha corretamente os dados abaixo para cadastrar um novo Estoque.'}
          </DialogContentText>

          <Box sx={{ p: 2, backgroundColor: "#fafafa" }} >
            <FormControl variant="standard" fullWidth >
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={2}
              >
                <Grid item xs={12} md={6}>
                  <TextField
                    autoFocus
                    InputLabelProps={{ shrink: true }}
                    margin='dense'
                    label='Nome'
                    placeholder='Digite o nome do Estoque'
                    name='nome'
                    fullWidth
                    {...register("nome", { required: true })}
                    error={!!errors.nome}
                    helperText={getFormErrorMessage(errors, 'nome')}
                    variant="outlined"
                  />
                </Grid>

                {empresas &&
                  <Grid item xs={12} md={6}>
                    <Controller
                      name='id_empresa'
                      control={control}
                      rules={{ required: true }}
                      defaultValue={selectedStock ? selectedStock.empresas_id[0] : ""}
                      render={({ field: { ref, onChange, ...field } }) => (
                        <TextField
                          {...field}
                          select
                          fullWidth
                          sx={{ mt: 1 }}
                          label="Empresa"
                          onChange={(e) => {
                            setValue('id_empresa', e.target.value, { shouldDirty: true })
                            if (e.target.value) {
                              clearErrors("id_empresa");
                            }
                          }}
                          error={!!errors.id_empresa}
                          helperText={getFormErrorMessage(errors, 'id_empresa')}
                        >
                          {empresas.length > 0 ? (
                            [
                              ...empresas.filter(option => empresasHasModule.includes(option.id)).map(option => (
                                <MenuItem key={option.id} value={option.id}>
                                  {option.nomeFantasia}
                                </MenuItem>
                              )),
                              ...empresas.filter(option => !empresasHasModule.includes(option.id)).map(option => (
                                <MenuItem key={option.id} value={option.id} disabled>
                                  {option.nomeFantasia} - (Módulo Inativo)
                                </MenuItem>
                              ))
                            ]
                          ) : (
                            <MenuItem disabled>Nenhum disponível</MenuItem>
                          )}
                        </TextField>
                      )}
                    />
                  </Grid>
                }

                <Grid item xs={12}>
                  <TextField
                    InputLabelProps={{ shrink: true }}
                    margin='dense'
                    label='Descrição'
                    placeholder='Digite a Descrição'
                    name='descricao'
                    fullWidth
                    {...register("descricao")}
                    variant="outlined"
                    multiline
                    rows={3}
                    error={!!errors.descricao}
                    helperText={getFormErrorMessage(errors, 'descricao')}
                  />
                </Grid>
              </Grid>
            </FormControl>
          </Box>
        </DialogContent>

        <CommonDialogActionsForm errors={errors} isLoading={isLoading} setOpen={setOpen} />
      </form>
    </Dialog>
  </>);
}